import * as types from "../constants/actionTypes";
import * as tools from "../helpers/Tools";

export const inMemoryReducerInitialState = function () {
    return {
        waiting: false,
        success: true,
        response: null,
        hideBannerOnCrash: false,
        stayOnIncompleteForm: false,
        rxDown: window.serverData && window.serverData.data ? window.serverData.data.rxDown : false,
        aalDown: window.serverData && window.serverData.data ? window.serverData.data.aalDown : false,
        swhpDown: window.serverData && window.serverData.data ? window.serverData.data.swhpDown : false,
        epicEHRDown: window.serverData && window.serverData.data ? window.serverData.data.epicEHRDown : false,
        appVersion: "1.1.1.1",
        minAppVersion: "1.1.1.1",
        siteOutage: false,
        loginNotice: window.data && window.data.serverData ? window.data.serverData.loginNotice : null,
        headerMessage: window.data && window.data.serverData ? window.data.serverData.headerMessage : null,
        error: null,
        careGapAttachments: null
    };
};

export default function inMemoryReducer(state = inMemoryReducerInitialState(), action) {
    const type = action.type;

    if (type == types.GOT_APP_UPDATE) {
        if (action.success) {
            //debugger;
            state = {
                ...state,
                waiting: false,
                success: true,
                rxDown: action.data.rxDown,
                aalDown: action.data.aalDown,
                swhpDown: action.data.swhpDown,
                epicEHRDown: action.data.epicEHRDown,
                appVersion: action.data.appVersion,
                minAppVersion: action.data.minappversion, 
                siteOutage: action.data.siteoutage,
                loginNotice: action.data.loginNotice,
                headerMessage: action.data.headerMessage,

                error: null
            };
        }
        else if (action.failure) {
            state = {
                ...state,
                waiting: false,
                success: false,
                response: null,
                error: action.error
            };
        }
        //else {
        //    state = {
        //        waiting: true,
        //        request: action.data
        //    };
        //}

        // this comes from passing initial window object
        //if (action.data !== undefined) {
        //    return {
        //        ...state,
        //        rxDown: action.data.rxDown,
        //        aalDown: action.data.aalDown,
        //        swhpDown: action.data.swhpDown,
        //        epicEHRDown: action.data.epicEHRDown
        //    };
        //}
    }
    if (type == types.GET_CAREGAP_FILE_ATTACHMENTS) {
        state = {
            ...state,
            careGapAttachments: action.files
        }
    }
    return state;
}
